import { ComponentProps } from "react";
import { composeRenderProps, Radio } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { focusRing } from "./utils";

export function RadioCard({
  className,
  children,
  ...props
}: ComponentProps<typeof Radio> & {}) {
  return (
    <Radio
      {...props}
      className={composeRenderProps(className, (className, renderProps) =>
        twMerge(
          "border-theme-outline-variant hover:bg-theme-on-background-hover hover:border-theme-outline disabled:border-theme-outline-variant/40 cursor-pointer border transition-colors duration-200 disabled:cursor-not-allowed",
          renderProps.isSelected &&
            "border-theme-active hover:border-theme-active border-2",
          focusRing(renderProps),
          className,
        ),
      )}
    >
      {children}
    </Radio>
  );
}
